import { flow, pipe } from 'fp-ts/lib/function';
import { Role } from '@/entities/role';
import { chain, map } from 'fp-ts/lib/TaskEither';
import { formCodec, listCodec, recordCodec } from './codec';
import {
  createAuthorizedDeleteRequest,
  createAuthorizedGetRequest,
  createAuthorizedPostRequest,
  createAuthorizedPutRequest,
  decode,
  decodeId,
  decodeVersioned,
  fetchApi,
  setBody,
  setQuery,
  Versioned,
} from '../..';
import { addVersionForUpdate } from '../../request';
import { encodeRoleQuery, RoleQuery } from '@/services/api/resources/role/query';
import { filterCodec } from '@/services/api/resources/filter';
import { resourceBulkDelete } from '@/services/api/resources/bulkDelete';

const baseUrl = '/v2/roles';
const filterUrl = '/v2/filters/roles';
const recordUrl = (id: number): string => `${baseUrl}/${id}`;

export const list = (query: RoleQuery) => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  map(setQuery(encodeRoleQuery(query))),
  chain(fetchApi),
  chain(decode(listCodec)),
);

export const filter = () => pipe(
  filterUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(filterCodec)),
);

export const create = (group: Role) => pipe(
  baseUrl,
  createAuthorizedPostRequest,
  map(setBody(formCodec.encode(group))),
  chain(fetchApi),
  chain(decodeId),
);

export const get = flow(
  recordUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decodeVersioned(recordCodec)),
);

export const update = (id: number, group: Versioned<Role>) => pipe(
  id,
  recordUrl,
  createAuthorizedPutRequest,
  map(addVersionForUpdate(group.version)),
  map(setBody(formCodec.encode(group.data))),
  chain(fetchApi),
);

export const remove = flow(
  recordUrl,
  createAuthorizedDeleteRequest,
  chain(fetchApi),
);

export const bulkDelete = (records: number[]) => resourceBulkDelete(records, baseUrl);
